import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const Image = styled.div<{ $url?: string }>`
  content: ${(props) => (props.$url ? `url('${props.$url}')` : 'none')};
  padding: 0;
  margin: auto;
  max-width: 100%;
  min-height: 355px;

  @media (${breakpoint.xlMin}) {
    padding: 0 96px;
    min-height: 300px;
  }
`;
